import Rest from '@/services/Rest'
import qs from "qs";

export default class PendingConsentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/pendingConsents';

  search(parameters = {}) {
    return this.get(`/`, {
      params: parameters,
      paramsSerializer: params => { // Dobbiamo fare lo stringify perchè grails non capisce gli array non encodati
        return qs.stringify(params, { arrayFormat: 'repeat',  skipNulls: true})
      }
    })
  }
}
